import React from 'react';
import PropTypes from 'prop-types';

import linkifyIt from './linkify_it';

class Linkifier extends React.Component {
  constructor(props) {
    super(props);

    this.parseCounter = 0;
  }

  getMatches(string) {
    return linkifyIt.match(string);
  }

  parseString(string) {
    let elements = [];
    if (string === '') {
      return elements;
    }

    const matches = this.getMatches(string);
    if (!matches) {
      return string;
    }

    let lastIndex = 0;
    matches.forEach((match, idx) => {
      // Push the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(string.substring(lastIndex, match.index));
      }
      // Shallow update values that specified the match
      let props = {
        className: this.props.linkClassName,
        href: match.url,
        key: `parse${this.parseCounter}match${idx}`,
        ...this.props.properties,
      };
      let text =
        match.text.length <= this.props.truncateLength
          ? match.text
          : `${match.text.slice(0, this.props.truncateLength)}…`;
      elements.push(React.createElement(this.props.component, props, text));
      lastIndex = match.lastIndex;
    });

    if (lastIndex < string.length) {
      elements.push(string.substring(lastIndex));
    }

    return elements.length === 1 ? elements[0] : elements;
  }

  parse(children) {
    let parsed = children;

    if (typeof children === 'string') {
      parsed = this.parseString(children);
    } else if (React.isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
      parsed = React.cloneElement(
        children,
        { key: `parse${++this.parseCounter}` },
        this.parse(children.props.children)
      );
    } else if (children instanceof Array) {
      parsed = children.map(child => {
        return this.parse(child);
      });
    }

    return parsed;
  }

  render() {
    this.parseCounter = 0;
    const parsedChildren = this.parse(this.props.children);

    return <span className={this.props.className}>{parsedChildren}</span>;
  }
}

Linkifier.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  component: PropTypes.any,
  linkClassName: PropTypes.string,
  properties: PropTypes.object,
  truncateLength: PropTypes.number,
};

Linkifier.defaultProps = {
  component: 'a',
  properties: {
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  truncateLength: 75,
};

export default Linkifier;
